import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'My Safe Spaces';
const BASE_URL = 'https://www.mysafespaces.org';
const DEFAULT_IMAGE = '/mss/logo.png';

// Set REACT_APP_NOINDEX=true in Amplify Console for non-production branches
const noIndex = process.env.REACT_APP_NOINDEX === 'true';

const SEO = ({ title, description, path, type = 'website', schema, noIndexPage = false }) => (
  <Helmet>
    <title>{title}</title>
    <meta name="description" content={description} />
    <link rel="canonical" href={`${BASE_URL}${path}`} />
    {(noIndex || noIndexPage) && <meta name="robots" content="noindex, nofollow" />}
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta property="og:url" content={`${BASE_URL}${path}`} />
    <meta property="og:type" content={type} />
    <meta property="og:site_name" content={SITE_NAME} />
    <meta property="og:image" content={`${BASE_URL}${DEFAULT_IMAGE}`} />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={description} />
    {schema && (
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    )}
  </Helmet>
);

export default SEO;
